import { ROUTE_FROM_PEGNI, ROUTE_FROM_UNIMODWEB, ROUTE_PROFILAZIONE, ROUTE_ERROR , ROUTE_RESTITUZIONE_DUPLO , ROUTE_DUPLI_RESTITUITI, ROUTE_FERMO,ROUTE_FROM_PEGNI_CERTIFICATI,  ROUTE_FROM_UNIMODWEB_BB, ROUTE_FROM_CANCELLAZIONI_IPOTECA, ROUTE_ELENCHI, ROUTE_HOME, ROUTE_TRASMISSIONE } from "../frontendRouting";

export const getParam = (url, key) => {
    const query = new URLSearchParams(url);
    return query.get(key);
}

export const addParam = (url, key, param) => {
    let toUrl = ''
    if (url) {
        toUrl = url;
    }
    let connector = toUrl.includes('?') ? '&' : '?';
    return `${toUrl}${connector}${key}=${param}`;
}

export const isFromPegni = (url) => {
    if (!url) {
        return false;
    }
    return url.includes(`${ROUTE_FROM_PEGNI}/`);
}
export const isFromPegniCertificati = (url) => {
    if (!url) {
        return false;
    }
    return url.includes(`${ROUTE_FROM_PEGNI_CERTIFICATI}/`);
}
export const isFromCancellazioniIpoteca = (url) => {
    if (!url) {
        return false;
    }
    return url.includes(`${ROUTE_FROM_CANCELLAZIONI_IPOTECA}`);
}
export const isFromUnimodweb = (url) => {
    if (!url) {
        return false;
    }
    return url.includes(`${ROUTE_FROM_UNIMODWEB}/`);
}
export const isFromUnimodwebBB = (url) => {
    if (!url) {
        return false;
    }
    return url.includes(`${ROUTE_FROM_UNIMODWEB_BB}/`);
}

export const isFromTrasmissione = (url) => {
    if (!url) {
        return false;
    }
    return url.includes(`${ROUTE_TRASMISSIONE }/`);
}

export const isFromRestituzioneDuplo = (url) => {
    if (!url) {
        return false;
    }
    return url.includes(`${ROUTE_RESTITUZIONE_DUPLO}`);
}
export const isFromRicevuteDuplo = (url) => {
    if (!url) {
        return false;
    }
    return url.includes(`${ROUTE_DUPLI_RESTITUITI}`);
}

export const isFromHomeUN = (url) => {
    if (!url) {
        return false;
    }
    return url.includes(`${ROUTE_HOME}`)&& url.includes('UN');
}

export const isFromProfilazione = (url) => {
    if (!url) {
        return false;
    }
    return url.includes(`${ROUTE_PROFILAZIONE}`);
}

export const isFromError = (url) => {
    if (!url) {
        return false;
    }
    return url.includes(`${ROUTE_ERROR}`);
}

export const isFromFermo = (url) => {
    if (!url) {
        return false;
    }
    return url.includes(`${ROUTE_FERMO}`);
}


export const isFromElenchi = (url) => {
    if (!url) {
        return false;
    }
    return url.includes(`${ROUTE_ELENCHI}`);
}